<template>
  <MainFormLayout layout="two-column">
    <div class="rsc-onetrust-cookie-policy">
      <div class="text-right">
        <!-- OneTrust Cookies Settings button start -->
        <ButtonComponent
          label="Cookie settings"
          variant="secondary"
          id="ot-sdk-btn"
          @click="openCookieSettings"
        />
        <!-- OneTrust Cookies Settings button end -->
      </div>
      <!-- OneTrust Cookies List start -->
      <div id="ot-sdk-cookie-policy">
      </div>
      <!-- OneTrust Cookies List end -->
    </div>
  </MainFormLayout>
</template>

<script setup lang="ts">
interface OptanonType {
  ToggleInfoDisplay?: () => void
}
declare const Optanon: OptanonType

import MainFormLayout from '../layouts/MainFormLayout.vue'
import ButtonComponent from '../components/ui-components/ButtonComponent.vue'

const openCookieSettings = () => {
  if (typeof Optanon !== 'undefined' && Optanon.ToggleInfoDisplay) {
    Optanon.ToggleInfoDisplay()
  }
}
</script>
